import get from 'lodash.get';
import { getSlidesPerView } from './getSlidesPerView';
import { isSlidesLoopEnabled } from './isSlidesLoopEnabled';
export const getIndex = ({
  instanceRef,
  isAtTheEnd,
  isAtTheStart,
  setIsAtTheEnd,
  setIsAtTheStart,
  slider,
  slidesCount,
  type
}) => {
  const currentSlide = get(instanceRef, 'current.track.details.rel', 0);
  const slidesLoopEnabled = isSlidesLoopEnabled(slider);
  const slidesPerView = getSlidesPerView(slider);
  if (type === 'next') {
    if (Boolean(slidesLoopEnabled) && isAtTheEnd) {
      setIsAtTheEnd(false);
      setIsAtTheStart(true);
      return 0;
    }
    if (currentSlide + slidesPerView >= slidesCount - slidesPerView) {
      setIsAtTheEnd(true);
      setIsAtTheStart(false);
      return slidesCount - slidesPerView;
    }
    setIsAtTheEnd(false);
    setIsAtTheStart(false);
    return currentSlide + slidesPerView;
  }
  if (slidesLoopEnabled && isAtTheStart) {
    setIsAtTheEnd(true);
    setIsAtTheStart(false);
    return slidesCount - slidesPerView;
  }
  if (currentSlide - slidesPerView <= 0) {
    setIsAtTheEnd(false);
    setIsAtTheStart(true);
    return 0;
  }
  setIsAtTheEnd(false);
  setIsAtTheStart(false);
  return currentSlide - slidesPerView;
};
//# sourceMappingURL=getIndex.js.map